import { BotKind, load } from '@fingerprintjs/botd';

// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFunction(fn: Function): boolean {
  return /\{\s*\[native code\]\s*\}/.test(String(fn));
}

const checkIsInCdp = async () => {
  try {
    // ua check
    if (
      navigator.userAgent.includes('HeadlessChrome') ||
      navigator.userAgent.includes('puppeteer') ||
      navigator.userAgent.includes('PhantomJS')
    ) {
      return true;
    }
    // webdriver check
    if (navigator.webdriver) {
      return true;
    }
    // chrome extension check
    if (window.chrome && window.chrome.runtime && window.chrome.runtime.sendMessage) {
      return true;
    }
    // language check
    if (!window.navigator.languages || window.navigator.languages.length === 0) {
      return true;
    }
    // style check
    if (window.getComputedStyle(document.body).display === 'none') {
      return true;
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const prop in window) {
      if (
        prop.match(/cdc_[a-z0-9]/gi) ||
        (prop.includes('Devtools') && prop !== 'webpackChunkmodernjsDevtools') ||
        prop.startsWith('_cdp')
      ) {
        return true;
      }
    }

    // playwrite check
    if (window.__pwInitScripts || window.__playwright__binding__) {
      return true;
    }
    const _window = window as any;
    const _document = document as any;
    const conditions = [
      window.document.documentElement.getAttribute('webdriver'),
      '__webdriver_script_fn' in document,
      'webdriver' in window,
      _window._selenium,
      _document.__webdriver_evaluate,
      _document.__selenium_evaluate,
      _document.__webdriver_script_function,
      _document.__webdriver_script_func,
      _document.__webdriver_script_fn,
      _document.__fxdriver_evaluate,
      _document.__driver_unwrapped,
      _document.__webdriver_unwrapped,
      _document.__driver_evaluate,
      _document.__selenium_unwrapped,
      _document.__fxdriver_unwrapped,
      _window.callSelenium,
      _window._Selenium_IDE_Recorder,
      _window.Buffer,
      _window._phantom,
      _window.__nightmare,
      _window.callPhantom,
      _window.__phantomas,
      _window.emit,
      _window.spawn
    ];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < conditions.length; i++) {
      if (conditions[i]) {
        return true;
      }
    }

    if (!isNativeFunction(console.log)) {
      return true;
    }

    // 检测 navigator.plugins.item
    if (navigator.plugins && navigator.plugins.item) {
      if (!isNativeFunction(navigator.plugins.item)) {
        return true;
      }
    }

    const ratio = window.devicePixelRatio;
    // 自定义阈值：若 <0.5 或 >8 则判定可疑
    if (ratio < 0.5 || ratio > 8) {
      return true;
    }

    if (navigator.permissions && navigator.permissions.query) {
      const perm = await navigator.permissions.query({ name: 'notifications' });
      if (!['granted', 'denied', 'prompt'].includes(perm.state)) {
        return true;
      }
    }
  } catch (e) {}

  return false;
};
let lastCheckTimestamp = 0;
let isBot = false;
let isDevToolOpen = false;
let botKind: BotKind | undefined;

export const botDetect = async () => {
  if (Date.now() - lastCheckTimestamp > 1000 * 60 * 5) {
    try {
      const botd = await load({ monitoring: false });
      const result = botd.detect();
      isBot = result.bot;
      botKind = result.bot ? result.botKind : undefined;
      if (!isBot) {
        isBot = await checkIsInCdp();
      }
      if (!isBot) {
        const threshold = 160;
        const widthThreshold = window.outerWidth - window.innerWidth > threshold;
        const heightThreshold = window.outerHeight - window.innerHeight > threshold;
        // eslint-disable-next-line max-depth
        if (widthThreshold || heightThreshold) {
          isDevToolOpen = true;
          isBot = true;
        }
      }

      if (!isBot) {
        const e = new Error();
        Object.defineProperty(e, 'stack', {
          get() {
            if (!isDevToolOpen) {
              isBot = true;
              botKind = botKind ? botKind : ('cdp' as any);
            }
            isDevToolOpen = true;
          }
        });
        console.log(e);
      }
    } catch (e) {
      isBot = false;
      botKind = undefined;
    }
    lastCheckTimestamp = Date.now();
  }
  return { botKind, isBot, isDevToolOpen };
};
